import { AxiosInstance } from "axios";
import { ResponseDto, ResponseLSDto } from "@common/ict/model/interface/common";
export class HomeApi {
  //获取轮播图或者宣传位 type 1: 首页轮播2: 宣传位轮播
  static getBanner(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `zh-business/client/v1/home/carousel/page/list`,
      {
        params: query
      }
    );
  }
  static getSuccessCase(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/home/success/cases/detail/page/list`,
      {
        params: query
      }
    );
  }
  static getNewArrival(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/new/arrival/page/list`,
      {
        params: query
      }
    );
  }
  static getNewArrivalDetail(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/new/arrival/detail`,
      {
        params: query
      }
    );
  }
  static getDynamic(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/dynamic/page/list`,
      {
        params: query
      }
    );
  }
  static getDynamicTogether(request: AxiosInstance, query) {
    return request.get<ResponseDto, ResponseDto>(
      `/zh-business/client/v1/dynamic/page/list`,
      {
        params: query
      }
    );
  }
  
  // 需求反馈枚举
  static getProductList(request: AxiosInstance, data) {
    return request.get<any, any>(`/zh-business/client/v1/combo/page/list`, {
      params: data
    });
  }
  // 新增 需求反馈
  static createFeedback(request: AxiosInstance, data) {
    return request.post<any, any>(`/zh-business/client/v1/feedback/add`, data);
  }
  // 获取 二维码
  static getCode(request: AxiosInstance) {
    return request.get<any, any>(`/zh-business/client/v1/feedback/code`);
  }
  // 个人隐私数据新增
  static privacyPersonal(request: AxiosInstance, data) {
    return request.post<ResponseDto, ResponseLSDto>(
      "zh-business/client/v1/revoke/add",
      data
    );
  }
}
